export const CASHBACK_MAINTENANCE_MESSAGE = "O cashback está temporariamente inativo para atualização. Estamos preparando melhorias para você e voltaremos em breve!";
